// EvaluationModal.js
import React from 'react';
import { DialogActions, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { makeStyles } from "tss-react/mui";
import Button from '../../Button';

const useStyles = makeStyles()((theme) => ({
    actionContainer: {
        justifyContent: 'center',
        marginBottom: '1rem'
    },
    actionBtn: {

    }
}));

export default function TakeSpeechEvaluation ({ open, handleStartEvaluation }) {
    const {classes} = useStyles();

    return (
        <Dialog
            open={open}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <DialogTitle>Ready to Start Speech Evaluation?</DialogTitle>
            <DialogContent>
                Great to see that you heard the passage! 
                Now it's your turn to speak the same passage and check if it's correct.
            </DialogContent>
            <DialogActions className={classes.actionContainer}>
                <Button variant="contained" className={classes.actionBtn} onClick={handleStartEvaluation} placeholder={'Start Speech Evaluation'} />
            </DialogActions>
        </Dialog>
    );
};